<div>
    <mat-card appearance="outlined">
        <mat-card-title style="margin: 15px;">
            Search Job Card
        </mat-card-title>
        <mat-card-content>
            <div class="search-container">
                <form [formGroup]="requestForm">
                    <div class="search-section">
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Job Card Status</mat-label>
                            <mat-select formControlName="jobCardStatus" placeholder="Job Card Status">
                                <mat-option *ngFor="let status of jobCardStatus" [value]="status.lookupCode">
                                    {{ status.lookupValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Department</mat-label>
                            <mat-select formControlName="departmentId" placeholder="Department">
                                <mat-option *ngFor="let department of departments" [value]="department.code">
                                    {{ department.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Area Name</mat-label>
                            <mat-select formControlName="areaId" placeholder="Area Name">
                                <mat-option *ngFor="let area of areas" [value]="area.code">
                                    {{ area.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Employee</mat-label>
                            <mat-select formControlName="employeeId" placeholder="Employee">
                                <mat-option *ngFor="let employee of employees" [value]="employee.code">
                                    {{ employee.value }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Complaint Status</mat-label>
                            <mat-select formControlName="complaintStatus" placeholder="Complaint Status">
                                <mat-option *ngFor="let status of complaintStatus" [value]="status.lookupCode">
                                    {{ status.lookupValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Complaint Number</mat-label>
                            <input matInput formControlName="complaintNumber" placeholder="Complaint Number"/>
                        </mat-form-field>
                        <mat-form-field appearance="outline" style="margin-right: 10px;">
                            <mat-label>Job Card Number</mat-label>
                            <input matInput formControlName="jobCardNumber" placeholder="Job Card Number"/>
                        </mat-form-field>
                    </div>
                </form>
                <div class="buttons">
                    <button mat-flat-button color="primary" (click)="onSearch()">Search</button>
                    <button mat-stroked-button color="warn" (click)="onReset()">Reset</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
<div style="margin-top: 25px; margin-bottom: 20px;">
    <mat-card appearance="outlined">
        <mat-card-title style="margin: 15px;">
            Job Card Details
        </mat-card-title>
        <mat-card-title style="margin-left: 15px; margin-bottom: 10px;" *ngIf="showActions">
            <button mat-flat-button [matMenuTriggerFor]="menu" *ngIf="showJobCardActionButton" [disabled]="isProcessing">
                <mat-icon>keyboard_arrow_down</mat-icon>
                Job Card Actions
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item *ngIf="showInProgressJobCardAction" (click)="updateJobCardStatus('IN_PROGRESS')">In Progress</button>
                <button mat-menu-item *ngIf="showCloseJobCardAction" (click)="updateJobCardStatus('CLOSED')">Close Job</button>
                <button mat-menu-item *ngIf="showWaitingStoresAction" (click)="updateJobCardStatus('WAITING_STORES')">Waiting For Store</button>
                <button mat-menu-item *ngIf="showOnHoldJobCardAction" (click)="updateJobCardStatus('HOLD')">On Hold</button>
                <button mat-menu-item *ngIf="showDiscardAction" (click)="updateJobCardStatus('DISCARD')">Discard Job</button>
                <button mat-menu-item *ngIf="showApprovalRequiredAction" (click)="updateJobCardStatus('APPROVAL_REQUIRED')">Unauthorized</button>
            </mat-menu>

            <button style="margin-left: 10px;" mat-flat-button [matMenuTriggerFor]="matMenuPrintJobCard" *ngIf="showPrintJobCard" [disabled]="isProcessing">
                <mat-icon>keyboard_arrow_down</mat-icon>
                Print Job Card
            </button>
            <mat-menu #matMenuPrintJobCard="matMenu">
                <button mat-menu-item (click)="printJobCardEmpWise('rptJobcardplain')">Print Job Card</button>
                <button mat-menu-item (click)="printJobCardEmpWise('JobCard_EmpWise')">Print Job Card Employee Wise</button>
                <button mat-menu-item (click)="printJobCardEmpWise('JobCard_Location')">Print Job Card Location Wise</button>
            </mat-menu>

            <button mat-flat-button style="margin-left: 10px;" (click)="viewComplaintHistory()" *ngIf="showViewHistoryButton" [disabled]="isProcessing">View History</button>
            <button mat-flat-button style="margin-left: 10px;" (click)="issueJobCard()" *ngIf="showIssueJobCardButton" [disabled]="isProcessing">Issue Job Card</button>
            <button mat-flat-button style="margin-left: 10px;" (click)="issueJobCard()" *ngIf="showIssueAdditionalJobCardButton" [disabled]="isProcessing">Issue Additional Job Card</button>
            <button mat-flat-button style="margin-left: 10px;" (click)="transferComplaint()" *ngIf="showTransferComplaintButton" [disabled]="isProcessing">Transfer Complaint</button>
            <!-- <button mat-stroked-button style="margin-left: 10px;">Assign Employee</button> -->
            <button mat-flat-button style="margin-left: 10px;" *ngIf="showResendOtpButton && showResendOTP" (click)="resendOtp()" [disabled]="isProcessing">Resend OTP</button>
        </mat-card-title>
        <mat-card-content>
            <div>
                <table mat-table [dataSource]="dataSource" matSort class="mat-table">
                    <!-- Complaint No Column -->
                    <ng-container matColumnDef="complaintNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint / Jobcard No</th>
                        <td mat-cell *matCellDef="let element"> {{ element.compositeComplaintNumber }} / {{ element.jobCardNumber ? element.jobCardNumber : '-' }}</td>
                    </ng-container>
    
                    <!-- Complaint Status Column -->
                    <ng-container matColumnDef="complaintStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Complaint Status </th>
                        <td mat-cell *matCellDef="let element" [class.cell-loading]="isRowProcessing(element)">
                            <span *ngIf="!isRowProcessing(element)">{{ getComplaintStatusValue(element.complaintStatus) }}</span>
                            <span *ngIf="isRowProcessing(element)" class="loading-text">Updating…</span>
                        </td>
                    </ng-container>
    
                    <!-- Location Column -->
                    <ng-container matColumnDef="location">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
                        <td mat-cell *matCellDef="let element"> {{ element.compositeLocation }} </td>
                    </ng-container>
    
                    <!-- Complaint Description Column -->
                    <ng-container matColumnDef="complaintDescription">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Complaint Description </th>
                        <td mat-cell *matCellDef="let element"> {{ element.complaintDescription }} </td>
                    </ng-container>
    
                    <!-- Complaint Date Column -->
                    <ng-container matColumnDef="complaintDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Complaint Date </th>
                        <td mat-cell *matCellDef="let element"> {{ element.complaintDate | date }} {{ element.complaintDate
                            | date:'shortTime' }}</td>
                    </ng-container>
    
                    <!-- Complaint Due Date Column -->
                    <ng-container matColumnDef="dueDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Complaint Due Date </th>
                        <td mat-cell *matCellDef="let element">{{ element.dueDate | date }} {{ element.dueDate |
                            date:'shortTime' }}</td>
                    </ng-container>
    
                    <!-- Job Card No Column -->
                    <ng-container matColumnDef="taskDeptName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name / Department</th>
                        <td mat-cell *matCellDef="let element">{{ element.complaintAssignEmpName ? element.complaintAssignEmpName : '' }} / {{ element.taskDeptName ? element.taskDeptName : '' }}
                        </td>
                    </ng-container>

                     <!-- Job Card Assigned To / Status Column -->
                    <ng-container matColumnDef="jobCardStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Job Card Assigned To / Status </th>
                        <td mat-cell *matCellDef="let element" [class.cell-loading]="isRowProcessing(element)">
                            <span *ngIf="!isRowProcessing(element)">{{ element.taskEmpFName ? element.taskEmpFName : '-' }} / {{ getJobCardStatusValue(element.taskStatus) ? getJobCardStatusValue(element.taskStatus) : '-' }}</span>
                            <span *ngIf="isRowProcessing(element)" class="loading-text">Updating…</span>
                        </td>
                    </ng-container>
    
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>Select</th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckboxChange(element)"
                                [checked]="selection.isSelected(element)" [disabled]="isProcessing">
                            </mat-checkbox>
                        </td>
                    </ng-container>
    
                    <!-- Header and Row Declarations -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
                        [class.row-updated]="isRecentlyUpdated(row)" 
                        [class.row-processing]="isRowProcessing(row)"></tr>
                </table>
    
                <!-- MatPaginator for Pagination -->
                <mat-paginator [length]="totalItems" [pageSize]="10" [pageSizeOptions]="[10, 20, 50, 100]"
                    showFirstLastButtons (page)="onPaginateChange($event)" style="margin-bottom: 20px;">
                </mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</div>
